import get from 'lodash/get';

import API from '@wetransfer/transfer/api';
import ErrorHandler from '@wetransfer/transfer/modules/error-handler';
import ActionHelper from '@wetransfer/transfer/modules/redux-actions';
import Router from '@wetransfer/transfer/modules/router';
import Notification from '@wetransfer/transfer/store/action/notification';

export const actions = ActionHelper.types([
  'RECEIVED_TRANSFERS_SUCCESS',
  'GET_RECEIVED_TRANSFER_SUCCESS',
  'RECEIVED_TRANSFERS_RESET_TRANSFER',
]);

export default ActionHelper.generate({
  list() {
    return async (dispatch) => {
      try {
        const response = await API.TransfersReceived.getReceivedTransfers();

        dispatch({
          type: actions.RECEIVED_TRANSFERS_SUCCESS,
          list: response.body || [],
        });
      } catch (error) {
        ErrorHandler.track(error);
      }
    };
  },

  getReceivedTransfer(id) {
    return async (dispatch) => {
      try {
        const response = await API.TransfersReceived.getReceivedTransferById(
          null,
          {
            pathExtValues: {
              transferId: id,
            },
          }
        );

        dispatch({
          type: actions.GET_RECEIVED_TRANSFER_SUCCESS,
          transfer: response.body || null,
        });
      } catch (error) {
        const message = get(error.body, 'error', 'retrieve_transfer_exception');
        Router.navigateTo('/transfers');
        dispatch(Notification.setNotification('error', message));
      }
    };
  },

  resetReceivedTransfer: [actions.RECEIVED_TRANSFERS_RESET_TRANSFER],
});
